<template>
     <div class="academicLiteratureDetailTop">
            <div class="bg"></div>
            <div class= "card" >
                <div class="title van-multi-ellipsis--l2">{{data.title}}</div>
                <div class="center">
                        <template v-if="!more">
                            <div class="van-ellipsis"  v-show="data.journal_name">《{{data.journal_name}}》</div>
                            <div style="min-width:0.8rem;">{{data.publish_date}}</div>
                        </template>
                        <template v-else>
                           <div >《{{data.journal_name}}》 {{data.publish_date}}</div>
                        </template>
                  
                </div>
                <div class="footer" v-show="more"> {{data.author}} </div>
                <div class="more" v-show="data.author" @click="handleMore">
                    <span>{{!more ? '更多': '收起'}}</span> 
                    <i class="iconfont" v-show='!more'>&#xe6c0;</i>
                    <i class="iconfont" style="transform: rotate(180deg);" v-show='more'>&#xe6c0;</i>

                </div>
            </div>
        </div>
</template>
<script>
export default {
    data(){
        return {
            more: false
        }
    },
    props:{
        data:{
            type: Object,
            default:()=>{}
        }
    },
    methods:{
        handleMore(){
            this.more = !this.more
        }
    }
  
}
</script>
<style lang="less">
 .academicLiteratureDetailTop{
        width: 100%;
        height: 140px;
        position: relative;
        z-index: 2;
        
        .bg{
            width: 100%;
            height: 50px;
            background:linear-gradient(233deg,rgba(255,142,46,1) 0%,rgba(246,120,43,1) 100%);        
        }
        .card{
            overflow: hidden;
            background:rgba(255,255,255,1);
            box-shadow:0px 1px 6px 0px rgba(221,221,221,1);
            border-radius:6px;
            padding:0.15rem 0.16rem;
            margin:0 0.16rem;
            position: absolute;
            left: 50%;
            margin-left:-45%;
            top: 0.2rem;
            width:90%;
            padding-bottom: 0.10rem;
            .center{
                display:flex;
                align-items:center;
                font-size: 12px;
                color: #999999;
                margin-top: 4px;
            }
            .title{
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                color:#333333;
                font-weight:600;
                font-size: 16px;

            }
            .footer{
                font-size:12px;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:400;
                margin-top:0.04rem;
            }
            .more{
               color: #BBBBBB;
               font-size: 12px; 
               margin-top:0.08rem;
               width:100%;
               display: flex;
               justify-content: center;
               span{
                   cursor: pointer;
               }
               i{
                   font-size: 12px;
                    cursor: pointer;

               }
            }
        }
        .card::before {
            content:'';
            position: absolute;
            left: 0;
            top: 0;
            width:0.53rem;
            height: 0.41rem;
            background:linear-gradient(309deg,rgba(255,221,114,1) 0%,rgba(255,165,88,1) 100%);
            opacity:0.2;
            border-bottom-right-radius:80%;
        }
           .card::after {
            content:'';
            position: absolute;
            right:  0;
            bottom: 0;
            width:0.53rem;
            height: 0.41rem;
            background:linear-gradient(309deg,rgba(255,197,114,0.71) 0%,rgba(255,137,88,1) 100%);
            opacity:0.15;
            border-top-left-radius:80%;
        }
    }
</style>